import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable R2B request to shop feature
 */
export const R2B_REQUEST_TO_SHOP_ENABLED_250915 =
  'R2B_REQUEST_TO_SHOP_ENABLED_250915' as SettingConst<
    'R2B_REQUEST_TO_SHOP_ENABLED_250915',
    boolean,
    'RETAILER'
  >;
